import { useState, useEffect } from 'react'

const updatedCountdown = (distance) => {
  return {
    days: Math.floor(distance / (1000 * 60 * 60 * 24)),
    hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
    minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((distance % (1000 * 60)) / 1000),
  }
}

const useCountdownFrom = (endDateString = 'May 19, 2021 09:00:00') => {
  const endDate = new Date(endDateString).getTime()
  const [countdown, setCountdown] = useState(updatedCountdown(0))
  const [distance, setDistance] = useState(0)

  const timer = setTimeout(() => {
    const now = new Date().getTime()
    setDistance(endDate - now)
  }, 1000)

  useEffect(() => {
    setCountdown(updatedCountdown(distance))
  }, [distance])

  if (distance < 0) {
    clearInterval(timer)
  }

  return {
    countdown,
    isCounting: !!(Object.values(countdown).reduce((a, b) => a + b) > 0),
  }
}

export default useCountdownFrom
